<template>
  <div class="animated fadeIn">
    <b-row class="mt-3" >
      <b-col sm="12" class="text-center">
        <h1 style="color: green;"><i class="fa fa-check"></i></h1>
        <h1 style="color: green;">{{ebookPrice == 0 ? "Por ser cliente fiel do Sleeker, seu eBook será gerado gratuitamente e enviado para o seu Email" : "Seu pedido foi registrado!"}}</h1>
      </b-col>
    </b-row>
    <b-row class="mt-3" >
      <b-col sm="6" offset-sm="3">
        <b-button @click="goToPayments()" variant="success" style="width: 100%;">{{ebookPrice == 0 ? 'Voltar para o Sleeker' : 'Pagar e receber meu eBook'}}</b-button>
      </b-col>
    </b-row>
      <b-row>
        <b-col  sm="6" offset-sm="3">
          <b-card header-tag="header" style="background-color: #c9e7f1; margin-top: 30px;">
            <b-card-body>
              <b-row>
                  <b-col>
                      <h2>Como posso usar este e-book?</h2>
                  </b-col>
              </b-row>
              <b-row>
                  <b-col>
                      <p class="lead my-4">
                          O e-book é seu e você pode usá-lo como quiser. Nós temos algumas sugestões:
                      </p>
                      <ul class="list-unstyled mb-0">
                          <li class="py-2">
                              <div class="d-flex align-items-center">
                                  <div>
                                      <b-badge v-b-tooltip.hover variant="success" title="Escolha a capa, o título e coloque sua logo. Selecione entre mais de 100 páginas de conteúdo."><i class="fa fa-book"></i></b-badge>
                                  </div>
                                  <div id="test" style="margin-left: 10px;">
                                      <span class="h6 mb-0">Vender diretamente para as pessoas ou usando plataformas como Hotmart ou Eduzz;</span>
                                  </div>
                              </div>
                          </li>
                          <li class="py-2">
                              <div class="d-flex align-items-center">
                                  <div>
                                      <b-badge v-b-tooltip.hover variant="success" title="Escolha a capa, o título e coloque sua logo. Selecione entre mais de 100 páginas de conteúdo."><i class="fa fa-book"></i></b-badge>
                                  </div>
                                  <div id="test" style="margin-left: 10px;">
                                      <span class="h6 mb-0">Compartilhar nas redes sociais como conteúdo gratuito para os seu seguidores;</span>
                                  </div>
                              </div>
                          </li>
                          <li class="py-2">
                              <div class="d-flex align-items-center">
                                  <div>
                                      <b-badge v-b-tooltip.hover variant="success" title="Escolha a capa, o título e coloque sua logo. Selecione entre mais de 100 páginas de conteúdo."><i class="fa fa-book"></i></b-badge>
                                  </div>
                                  <div id="test" style="margin-left: 10px;">
                                      <span class="h6 mb-0">Enviar para pacientes para incrementar o seu atendimento;</span>
                                  </div>
                              </div>
                          </li>
                          <li class="py-2">
                              <div class="d-flex align-items-center">
                                  <div>
                                      <b-badge v-b-tooltip.hover variant="success" title="Escolha a capa, o título e coloque sua logo. Selecione entre mais de 100 páginas de conteúdo."><i class="fa fa-book"></i></b-badge>
                                  </div>
                                  <div id="test" style="margin-left: 10px;">
                                      <span class="h6 mb-0">Compartilhar em listas de transmissão de clientes e potenciais clientes;</span>
                                  </div>
                              </div>
                          </li>
                          <li class="py-2">
                              <div class="d-flex align-items-center">
                                  <div>
                                      <b-badge v-b-tooltip.hover variant="success" title="Escolha a capa, o título e coloque sua logo. Selecione entre mais de 100 páginas de conteúdo."><i class="fa fa-book"></i></b-badge>
                                  </div>
                                  <div id="test" style="margin-left: 10px;">
                                      <span class="h6 mb-0">Distribuir o material solicitando email para formar uma lista de emails de potenciais clientes;</span>
                                  </div>
                              </div>
                          </li>
                          <li class="py-2">
                              <div class="d-flex align-items-center">
                                  <div>
                                      <b-badge v-b-tooltip.hover variant="success" title="Escolha a capa, o título e coloque sua logo. Selecione entre mais de 100 páginas de conteúdo."><i class="fa fa-book"></i></b-badge>
                                  </div>
                                  <div id="test" style="margin-left: 10px;">
                                      <span class="h6 mb-0">Imprimir e entregar na primeira consulta para encantar o seu paciente;</span>
                                  </div>
                              </div>
                          </li>
                      </ul>
                  </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
    </b-row>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import service from "../service";


export default {
  name: 'Tutorial',
  data () {
    return {
      me: undefined,
      isMobileScreen: isMobile,
      tutorials:  [],
      pendingEmailConfirmation: false,
      ebookPrice: 27
    }
  },
  computed: {
    templateName() {
      return localStorage.templateName;
    },
    whitelabelName() {
      return localStorage.whitelabelName;
    },
    youtubeTutorial() {
      return localStorage.youtubeTutorial;
    }
  },
  methods: {
    goToPayments: function() {
      if (this.ebookPrice == 0) {
        this.$router.push("/home");
      } else if (this.ebookPrice == 19) {
        this.$router.push("/payments/load?pagae=7WQZCztup");
      } else {
        this.$router.push("/payments/load?pagae=7WQsjuNNP");
      }
    }
  },
  created() {
    if (this.$route.query.free) {
      this.ebookPrice = 0;
    } else {
      service.getEbookPrice().then(result => {
        this.ebookPrice = result.ebookPrice;
      });
    }

    service.getMe().then(me => {
      if (!me.emailConfirmationTime) {
        this.pendingEmailConfirmation = true;
        this.me = me;
      }
    })
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.row-eq-height {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
</style>
